<script setup>
import tipsComponets from '@/components/activity/tipsComponets.vue';
import Sidebar from './Sidebar.vue'
import Navbar from './Navbar.vue'
import NavbarMobile from './NavbarMobile.vue'
import AppMain from './AppMain.vue'
import { useStore } from 'vuex'
import { computed } from 'vue';
// 活动相关
const isActivity = computed(() => store.getters.isActivity);

const store = useStore()
</script>

<template>
    <div v-if="isActivity">
        <tipsComponets></tipsComponets>
    </div>
  <div class="app-wrapper">
    <Sidebar class="sidebar-container" />
    <div class="main-container" >
      <Navbar />
      <NavbarMobile />
      <AppMain />
    </div>
  </div>
</template>

<style lang="less" scoped>
.app-wrapper {
    height: 100%;
    width: 100%;
    display: flex;
    position: fixed;
}
.main-container {
  height: 100vh;
  flex-grow: 1;
  overflow: auto;
  background: #f8f8f8;
}
</style>
